import axiosTouri from "../../axiosTuri";

// Get All Tourguide Reservation
export const getAllTourguideReservation = async () => {
  const res = await axiosTouri.get(`tourguide-reservations`);
  if (res.data.status == "success") {
    return res.data;
  }
};
